var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4326_179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 16,
    height: 16,
    transform: "rotate(180 16 16)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4326_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00365 5.98333C8.08142 5.98333 8.15631 5.99733 8.22831 6.02533C8.30076 6.05289 8.36476 6.09444 8.42031 6.15L11.4203 9.15C11.5203 9.25 11.5703 9.36667 11.5703 9.5C11.5703 9.63333 11.5203 9.75 11.4203 9.85C11.3203 9.95 11.2036 10 11.0703 10C10.937 10 10.8203 9.95 10.7203 9.85L8.00365 7.13333L5.28698 9.85C5.18698 9.95 5.07031 10 4.93698 10C4.80365 10 4.68698 9.95 4.58698 9.85C4.48698 9.75 4.43698 9.63333 4.43698 9.5C4.43698 9.36667 4.48698 9.25 4.58698 9.15L7.58698 6.15C7.64254 6.09444 7.70631 6.05289 7.77831 6.02533C7.85076 5.99733 7.92587 5.98333 8.00365 5.98333Z",
    fill: "#81878C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.dbbe4b446f799f9f8d270a92eeca0761.svg";
export { ForwardRef as ReactComponent };